import React from 'react';
import { useAuth } from '../contexts/AuthContext';

interface RoleGuardProps {
  roles?: string | string[];
  permissions?: string | string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const RoleGuard: React.FC<RoleGuardProps> = ({
  roles,
  permissions,
  children,
  fallback = null,
}) => {
  const { isRole, hasPermission } = useAuth();

  const hasRequiredRole = roles ? isRole(roles) : true;
  const hasRequiredPermission = permissions
    ? Array.isArray(permissions)
      ? permissions.some(p => hasPermission(p))
      : hasPermission(permissions)
    : true;

  if (hasRequiredRole && hasRequiredPermission) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export default RoleGuard;
